import TrendingCrossPlatformStory from './components/trending-cross-platform-story.component';
import { useQuery } from '@tanstack/react-query';
import { fetchPerspectiveGroups } from '../../../apis/perspectives.api';
import { TAB_LIST_DISCOVERY } from '../../../constants/article.constant';
import {
  YourPerspectiveMatters,
  NeedsCommunityVoices,
  CompactPerspectivesSidebar
} from '../../Perspectives/PerspectivesSidebar';

const RightContentComponent = ({ selected }) => {
  const isPerspectivesTab = selected?.type === TAB_LIST_DISCOVERY.PERSPECTIVES;

  const { data } = useQuery({
    queryKey: ['perspectiveGroups'],
    queryFn: () => fetchPerspectiveGroups({ limit: 20 }),
    staleTime: 60_000,
    enabled: isPerspectivesTab
  });

  const groups = data?.data || [];

  return (
    <div className="w-full">
      <div className="flex flex-col gap-5 w-full overflow-y-auto overflow-x-hidden p-1">
        {isPerspectivesTab ? (
          <>
            <YourPerspectiveMatters />
            <NeedsCommunityVoices groups={groups} />
          </>
        ) : (
          <CompactPerspectivesSidebar />
        )}
        {/* <TrendingCrossPlatformStory /> */}
      </div>
    </div>
  );
};

export default RightContentComponent;
